import { render, staticRenderFns } from "./DashboardGAPageViewsCard.vue?vue&type=template&id=2597b81f&"
import script from "./DashboardGAPageViewsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardGAPageViewsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports